import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "section-header" }
const _hoisted_3 = { class: "section-title" }
const _hoisted_4 = {
  key: 0,
  class: "filter-count"
}
const _hoisted_5 = { class: "section-filters" }
const _hoisted_6 = { class: "section-filter-fields" }
const _hoisted_7 = { class: "section-filter-actions" }
const _hoisted_8 = {
  key: 0,
  class: "section-loading"
}
const _hoisted_9 = {
  key: 1,
  class: "section-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardFilterChips = _resolveComponent("DashboardFilterChips")!

  return (_openBlock(), _createElementBlock("section", {
    id: _ctx.sectionId,
    class: "dashboard-section"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createElementVNode("button", {
        type: "button",
        class: "btn-filters",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleFilters && _ctx.toggleFilters(...args)))
      }, [
        _createTextVNode(_toDisplayString(_ctx.filtersOpen ? "Hide Filters" : "Filters") + " ", 1),
        (_ctx.filterCount)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.filterCount), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_DashboardFilterChips, {
      chips: _ctx.chips,
      onRemove: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('remove', $event)))
    }, null, 8, ["chips"]),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _renderSlot(_ctx.$slots, "filters")
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          type: "button",
          class: "btn-apply",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
        }, "Apply"),
        _createElementVNode("button", {
          type: "button",
          class: "btn-reset",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
        }, "Reset"),
        _createElementVNode("button", {
          type: "button",
          class: "btn-reset",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.cancelFilters && _ctx.cancelFilters(...args)))
        }, "Cancel")
      ])
    ], 512), [
      [_vShow, _ctx.filtersOpen]
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Loading charts..."))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _renderSlot(_ctx.$slots, "default")
        ]))
  ], 8, _hoisted_1))
}